<template>
<div>
  <div id="impressaoPedido">
    <div class="txtRight">
      <p><b>Grupo|GC</b></p>
      <p><b>Contanto: </b></p>
      <p>site</p>
    </div>
    <div class="txtLeft">
      <b>Endereço: </b>
    </div>



    <h3 class="txtLeft mt-3">Detalhes do Cliente</h3>
    <hr>
    <div class="txtLeft">
      <b-row>
        <b-col cols="8">
          <b>Cliente: </b>
        </b-col>
        <b-col cols="4">
          <b>Contato: </b>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b>Fantasia: </b>
        </b-col>
        <b-col cols="4">
          <b>CNPJ: </b>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b>Endereço: </b>
        </b-col>
      </b-row>



      <h3 class="txtLeft mt-3">Detalhes do Pedido</h3>
      <hr>
      <b-row>
        <b-col cols="8">
          <b>Representante: </b>
        </b-col>
        <b-col cols="4">
          <b>Pedido: </b>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <b>Tipo Frete: </b>
        </b-col>
        <b-col cols="8">
          <b> Transp.: </b>
        </b-col>
        <b-col cols="8">
          <b>Condição de Pagamento: </b>
        </b-col>
        <b-col cols="4">
          <b>Forma de Pagamento: </b>
        </b-col>
      </b-row>





      <h3 class="txtLeft mt-3">Totais</h3>
      <hr>
      <b-row>
        <b-col cols="10">
          <span>categoria</span>
        </b-col>
        <b-col cols="2">
          <span>R$</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10">
          <b>Total</b>
        </b-col>
        <b-col cols="2">
          <b>R$</b>
        </b-col>
      </b-row>


      <h3 class="txtLeft mt-3">Observações</h3>
      <hr>
      <b-row>
        <b-col cols="3">
          <span>Tipo obs</span>
        </b-col>
        <b-col cols="9">
          <span>obs</span>
        </b-col>
      </b-row>
    </div>
    <b-row class="mt-5">
      <b-col class="border-top col-5 mt-5">
        <p>Representante</p>
      </b-col>
      <b-col class="border-top offset-2 col-5 mt-5">
        <p>Cliente</p>
      </b-col>
    </b-row>
  </div>
  <div id="impressaoListaPedidos" class="container p-5">
    <b-table :fields="fields" :items="items"></b-table>
  </div>
</div>
</template>
<script>
  // import jsPDF from 'jsPDF'

  export default {
    data () {
      return {
        fields: ['first_name', 'last_name', 'age'],
        items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' }
        ]
      }
    },
    methods: {
      imprimirPedido () {
        // let conteudo = document.getElementById('sua_div').innerHTML,
        //   telaImpressao = window.open('about:blank')
        // telaImpressao.document.write(conteudo)
        // telaImpressao.window.print()
        // telaImpressao.window.close()
        // let pdfName = 'test'
        // var doc = jsPDF()
        // doc.text(this.name, 10, 10)
        // doc.save(pdfName + '.pdf')
        this.teste()
      },
      teste: function () {
        let html = ''
        html += '<html>'
        html += '<head>'
        html += '</head>'
        html += '<body>'
        // inicio body
        html += '<h1>testando</h1>'
        // fim body
        html += '</body>'
        html += '</html>'
        let win = window.open('', '', 'height=700,width=700')
        win.write(html)
        // win.document.write('<html><head>');
        // win.document.write('<title>Relatório de vendas de Produtos</title>');   // <title> CABEÇALHO DO PDF.
        // //win.document.write(style)// INCLUI UM ESTILO NA TAB HEAD
        // win.document.write('</head>')
        // win.document.write('<body>')
        // win.document.write(tab)// O CONTEUDO DA TABELA DENTRO DA TAG BODY
        // win.document.write('</body></html>')
        win.document.close()// FECHA A JANELA
        win.print()
      }
    }
  }
</script>
<style scoped>
  #impressaoPedido {
    padding: 6em;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/impressaoPedidoVue.vue